export const DEFAULT_NS = 'Default';
export const BENCHMARK_TEASER = 'BenchmarkTeaserXP';
export const ERROR_PAGES = 'ErrorPages';
export const REWARDS_CORE_PROGRAM = 'RewardsCoreProgram';
export const WEEKLY_SALES_BREAKDOWN = 'WeeklySalesBreakdown';
export const TEST_CAMPAIGN_EMAIL = 'TestCampaignEmail';
export const ANALYTICS_EVALUATE = 'AnalyticsEvaluate';
export const COUNTRIES_LIST = 'CountriesList';
